<template>
  <div class="container">
    <div class="footer">
      <div :class="['footer-up','type-area',{'type-area-en':$i18n.locale !== 'cn'}] ">
        <div class="left">
          <ul class="menu" v-for="(item,index) in $t('menu')" :key="index">
            {{ item.level1 }}
            <router-link tag="li" :key="index1" :id="index" :to="{ name:item1.name }" @click.native="setID($event,index1),$screenY(200)" :class="[{'menu-item':title(item1.name)}]" v-for="(item1,index1) in item.list1" > {{ item1.level2 }} </router-link>
          </ul>
          <span class="cut-off" />
          <div class="contact">
            <p class="us">{{ $t('contact') }}</p>

            <div class="tel">
              <p>0411-87595777</p>
              <p>0411-87595757</p>
            </div>
            <span class="clearfix" />
            <p class="address">{{ $t('address') }}</p>
          </div>
        </div>

        <div class="right">

        </div>
      </div>

      <div class="footer-down">
        <div class="type-area">
          <div class="left">
            <p>大连毅都集团有限公司</p>
            <p class="record" @click="openRecord()">辽ICP备19015191号</p>
          </div>
          <p class="right">Copyright © 2020 Dalian Yidu Group Co., Ltd. All rights reserved.</p>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  export default {
    name: "Footer",
    data(){
      return {
        routePath:''
      }
    },
    watch:{
      $route(to){
        this.routePath = to.path
      }
    },
    methods:{
      setID(e,index){

        // if(this.$route.path.includes('BusinessLine')){
        //   let index = e.target.id ? e.target.id : 0
          this.Bus.$emit('id1',index)
          this.setSession('ID1',index)
        // }
      },
      title(name){
        return this.routePath.includes(name);
      },
      openRecord(){
        window.open('http://beian.miit.gov.cn/','_blank')
      }
    },
    created() {
      // this.routePath = this.$route.path
    }
  }
</script>

<style lang="scss" scoped>
  .container{
    height: 274px;
    background: url("../assets/images/footer.jpg") center 0 no-repeat #f3f3f7;
  }
  .footer-up{
    height: calc( 274px - 61px );
  }
  .footer-up .left .menu,.footer-up .left .contact{
    padding-top: 25px;
    font-size:14px;
    font-weight:bold;
    color:rgba(152,159,172,1);
    line-height:34px;
  }
  .footer-up .left .menu{
    float: left;
    margin-right: 118px;
    text-align: center;
   li{
     margin-top: 5px;
     font-size:14px;
     font-weight:400;
     color:rgba(88,94,108,1);
     line-height:28px;
     cursor: pointer;
   }
    li:hover{
      text-decoration:underline ;
    }
   .menu-item{
     color: $gc-embellish;
   }
  }
  .footer-up .left .menu:nth-of-type(1),
  .footer-up .left .menu:nth-last-of-type(1){
    display: none;
  }
  .footer-up .left .menu:nth-of-type(2) li:nth-last-of-type(1){
    display: none;
  }

  .footer-up .left .contact{
    float: right;
  }
  .footer-up .left .contact .tel p ,
  .footer-up .left .contact .address{
    font-size:14px;
    font-weight:400;
    color:rgba(88,94,108,1);
    line-height:30px;
    border-radius:15px;
    padding-left: 39px;
  }
  .footer-up .left .contact .tel {
    margin-top: 31px;
    p{
      width: 160px;
    }
    p:nth-of-type(1) {
      float: left;
      background: url("../assets/images/页脚-电话.png") no-repeat 13px center #20232b;;
    }
    p:nth-of-type(2) {
      float: right;
      margin-left: 18px;
      background: url("../assets/images/页脚-传真.png") no-repeat 13px center #20232b;;
    }
  }
  .footer-up .left .contact .address{
    margin-top: 17px;
    background: url("../assets/images/页脚-定位.png") no-repeat 13px center #20232b;;
  }
  .footer-down{
    height: 61px;
    margin: auto;
    background:rgba(0,0,0,.3);
    .left{
      float: left;
      p{
        float: left;
      }
      .record{
        margin-left: 15px;
        cursor: pointer;
      }
      .record:hover{
        text-decoration: underline;
      }
    }
    .right{
      float: right;
    }
    P{
      font:400 16px Microsoft YaHei;
      color:rgba(63,66,77,1);
      line-height: 61px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue